/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m15.9998 29.9998c-.179 0-.36-.049-.52-.147-.551-.335-13.48-8.335-13.48-18.241 0-5.489 3.449-8.231 6.867-8.515 2.572-.213 5.538.999 7.133 4 1.622-3.059 4.67-4.293 7.31-4.072 3.222.267 6.69 2.856 6.69 7.91 0 9.193-12.871 18.488-13.419 18.879-.173.123-.377.186-.581.186" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;